/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_MediaInputs */

const en_social_media = /** @type {(inputs: Social_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Media`)
};

const de_social_media = /** @type {(inputs: Social_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Media`)
};

/**
* | output |
* | --- |
* | "Social Media" |
*
* @param {Social_MediaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const social_media = /** @type {((inputs?: Social_MediaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_MediaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_social_media(inputs)
	return en_social_media(inputs)
});